import { Instance, types } from 'mobx-state-tree'
import { MerchantStatus, statusTypes } from '../static/data'
import { Bank } from './Bank'
import { Contact } from './Contact'
import { Limits } from './Limits'

const BankAccount = types.model('BankAccount', {
  number: types.string,
  type: types.string,
  holderName: types.string,
  bank: Bank,
})

const SubMerchant = types.model('SubMerchant', {
  mid: types.string,
  businessName: types.string,
})

const Merchant = types
  .model('Merchant', {
    name: types.string,
    vpa: types.string,
    businessName: types.string,
    mid: types.string,
    tId: types.string,
    bankAccount: types.maybe(BankAccount),
    status: types.string,
    type: types.string,
    acceptedPayments: types.array(types.string),
    limits: types.array(Limits),
    age: types.string,
    authorisedSignatory: types.string,
    dailyTransactionVolume: types.string,
    contact: types.maybe(Contact),
    accessProfileId: types.maybe(types.string),
    jfsUserId: types.maybe(types.string),
    userStatus: types.optional(types.string, MerchantStatus.Active),
    subMids: types.array(SubMerchant),
  })

  .views((self) => ({
    merchantStatusString(): statusTypes {
      switch (self.status) {
        case MerchantStatus.Active:
          return statusTypes.Active
        case MerchantStatus.Inactive:
          return statusTypes.Inactive
        case MerchantStatus.Blocked:
          return statusTypes.Blocked
        case MerchantStatus.Suspend:
          return statusTypes.Suspend
        case MerchantStatus.HotMerchant:
          return statusTypes['Hot Merchant']
        case MerchantStatus.ClosedByMerchant:
          return statusTypes['Closed By Merchant']
        case MerchantStatus.ClosedByOps:
          return statusTypes['Closed By Ops Team']
        default:
          return statusTypes.Inactive
      }
    },
    isValidMerchant(): boolean {
      if (
        (self.status === MerchantStatus.Active || self.status === MerchantStatus.HotMerchant) &&
        self.userStatus === MerchantStatus.Active
      ) {
        return true
      }
      return false
    },
  }))

export { Merchant }
export type MerchantType = Instance<typeof Merchant>
